import { createFileRoute } from '@tanstack/react-router'
import { FlaskConical } from 'lucide-react'
import { z } from 'zod'
import { ContextPlaygroundScreen } from '@/screens/investigate/SCR-013-context'

export const Route = createFileRoute('/_app/w/$ws/context')({
  staticData: { screen: { id: 'SCR-013', title: 'Context playground', group: 'Investigate', perm: 'context.assemble', pin: true, order: 1, description: 'Build the context an agent would get for a question, and see why each memory is in it.', icon: FlaskConical } },
  validateSearch: z.object({
    q: z.string().max(8000).optional(),
    budget: z.coerce.number().int().min(64).max(16000).optional().catch(undefined),
    branch: z.string().max(200).optional(),
    compare: z.boolean().optional().catch(undefined),
  }),
  component: ContextPlaygroundScreen,
})
